export var CostProvider;
(function (CostProvider) {
    CostProvider["AWS"] = "aws";
    CostProvider["TELEPHONY"] = "telephony";
    CostProvider["OPENAI"] = "openai";
    CostProvider["DEEPGRAM"] = "deepgram";
})(CostProvider || (CostProvider = {}));
export var CostSource;
(function (CostSource) {
    CostSource["VANTAGE"] = "vantage";
    CostSource["NATIVE_AWS"] = "native-aws";
    CostSource["TWILIO"] = "twilio";
    CostSource["VONAGE"] = "vonage";
    CostSource["TELNYX"] = "telnyx";
    CostSource["BANDWIDTH"] = "bandwidth";
    CostSource["OPENAI"] = "openai";
    CostSource["DEEPGRAM"] = "deepgram";
})(CostSource || (CostSource = {}));
//# sourceMappingURL=cost-provider.js.map